// extracted by mini-css-extract-plugin
module.exports = {"announcementsContainer":"oXxFz","subtitle":"v7WOn","image":"_1FSoQ","content":"_2kP39"};